<template>
	<div :class="['menu', getMobile ? 'menu-burger__container' : '', getRouteLeave && !getMobile ? 'menu--leave' : '']" @mouseleave="resetHover">
		<ul class="niv-1" v-if="!getMobile">
			<li class="li-niv-1" v-for="(item, i) in getMenuData.body.items" @mouseover="setHover" :class="[niv1Path === i + 1 ? 'active' : '', isHome && niv1Target === i + 1 ? 'active' : '', isHome && !niv1Target ? 'default' : '', getPostCategory === item.object_slug ? 'active' : '' ]" :data-index="i + 1" key="item">
				<router-link :to="`/${item.object_slug}`"><span>{{ item.title }}</span></router-link>

				<ul class="niv-2">
					<li v-for="subitem in item.children" key="sub-item">
						<router-link :to="`/${subitem.object_slug}`">{{ subitem.title }}</router-link>
					</li>
				</ul>
			</li>
		</ul>

		<div :class="['burger-menu', menuOpen ? 'burger-menu--opened' : 'burger-menu--closed', getRouteLeave ? 'burger-menu--leave' : '']" v-else @click="setMenuState">
			<div class="bar"></div>
			<div class="bar"></div>
			<div class="bar"></div>
		</div>
	</div>
</template>

<script>
	import MenuMixin from '~mixins/Menu'

	export default {
		name: 'menu-comp',
		mixins: [MenuMixin],
		data () {
			return {
				menuOpen: false
			}
		},
		methods: {
			setMenuState () {
				this.menuOpen = !this.menuOpen

				this.$store.commit('setMenuState', this.menuOpen)
			}
		},
		watch: {
			getMenuState (val) {
				if (this.menuOpen !== val) {
					this.menuOpen = val
				}
			}
		},
		computed: {
			getMobile () {
				return this.$store.getters.getMobile
			},
			getMenuState () {
				return this.$store.getters.getMenuState
			},
			getRouteLeave () {
				return this.$store.getters.getRouteLeave
			}
		}
	}
</script>

<style lang="scss">
	.menu {
		ul {
			padding: 0;
			margin: 0;
		}

		&--leave {
			li {
				transform: translateY(-20px);
				opacity: 0;
			}
		}

		li {
			list-style-type: none;

			@for $i from 1 through 20 {
				&:nth-child(#{$i}) {
					transition: all .3s $i * .05s ease-in-out;
				}
			}

			&.default,
			&.active {
				> a {
					opacity: 1;
				}
			}
		}

		a {
			font-style: italic;
			opacity: .5;
			@include fontSize(15);
			@include transition(opacity .4s);

			&:hover {
				opacity: 1;
			}
		}

		.niv-1 {
			display: flex;
			align-items: center;

			> li {
				position: relative;
				margin-right: 50px;

				&:last-child {
					margin-right: 0;
				}

				a {
					position: relative;
					top: 3px;
					display: block;
					padding-bottom: 3px;

					span {
						position: relative;
						z-index: 10;
					}
				}

				> a {
					@include transition(color .4s);

					&::before {
						position: absolute;
						z-index: 5;
						bottom: 0%;
						left: -5%;
						width: 110%;
						height: 110%;
						background: $basic_black;
						opacity: 0;
						max-height: 0;
						content: "";
						@include transition(all .4s);
					}

					&:hover {
						color: $basic_white;

						&::before {
							opacity: 1;
							max-height: 110%;
						}
					}
				}

				&:hover {
					.niv-2 {
						opacity: 1;
						max-height: 400px;
						padding-top: 15px;
						transition: opacity .4s ease-in-out, max-height 0s, padding-top 0s;

						li {
							transform: translateX(0);
							opacity: 1;
						}
					}
				}
			}
		}

		.niv-2 {
			position: absolute;
			top: 20px;
			left: -8px;
			display: block;
			width: 200px;
			padding-top: 0;
			opacity: 0;
			max-height: 0;
			overflow: hidden;
			background: $basic_white;
			transition: opacity .4s ease-in-out, max-height 0s .5s, padding-top 0s .5s;

			li {
				position: relative;
				z-index: 3;
				transform: translateX(-5px);
				opacity: 0;
				padding-bottom: 5px;

				&:last-child {
					a {
						padding-bottom: 8px;
					}
				}
			}

			a {
				padding-right: 8px;
				padding-left: 8px;
				@include fontSize(13);
			}
		}
	}

	@keyframes lineLink {
		0% {
			transform: translateX(-105%);
		}
		100% {
			transform: translateX(200%);
		}
	}

	.menu-burger__container {
		position: relative;
		top: 4px;
		width: 40px;
		height: 40px;
	}

	.burger-menu {
		position: absolute;
		top: 0;
		right: 0;
		display: block;
		width: 40px;
		height: 40px;
		margin: 0 auto;
		transition: all .4s cubic-bezier(0.215, 0.61, 0.355, 1);
		cursor: pointer;

		&--leave {
			transform: translateY(-20px);
			opacity: 0;
		}

		.bar {
			display: block;
			width: 100%;
			height: 2px;
			background-color: $basic_black;
			transition: all .3s;
		}
      
		.bar:nth-of-type(2) {
			margin: 12px 0;
		}
      
		&--closed {
			transition-delay: .3s;

      .bar {
        float: right;
      }

      .bar:nth-of-type(2) {
        /* width: 75%; */
        transition-property: margin, height, width;
        transition-delay: .3s, .3s, 0s;
      }

      .bar:nth-of-type(3) {
        /* width: 50%; */
      }

      &:hover {
      	.bar:nth-of-type(2) {
        	width: 100%;
      	}

	      .bar:nth-of-type(3) {
	        width: 100%;
	      }
			} 
    }
         
    &--opened {
      padding-top: 12px;

      .bar:nth-of-type(1) {
        height: 3px;
        transform: rotate(45deg);
        transition-delay: .3s;
      }

      .bar:nth-of-type(2) {
        height: 0;
        margin: -3px;
        opacity: 0;
      }

      .bar:nth-of-type(3) {
        height: 3px;
      	transform: rotate(-45deg);
        transition-delay: .3s;
      }
    }
	}
</style>


// WEBPACK FOOTER //
// src/vue/components/common/header/Menu.vue?0e19a076